import { getId, Modal } from "@fluentui/react";
import { useEffect, useRef } from "react";
import ModalHeaderView from "../../common/views/ModalHeaderView";
import { StyleUtils } from "../../common/views/StyleUtils";
import useBrandVM from "../viewmodels/BrandVM";
import BrandGridView from "./BrandGridView";

export type BrandProps = {
    onClose: () => void;
}

export default function BrandView({ onClose }: BrandProps) {
    const hasLoaded = useRef(false);
    const vm = useBrandVM();

    useEffect(() => {
        if (hasLoaded.current) return;

        hasLoaded.current = true;

        vm.getList();
    }, [vm]);

    const isMobile = window.innerWidth <= 500;
    const titleId: string = getId('title');
    const subtitleId: string = getId('subText');

    return <>
        <Modal
            titleAriaId={titleId}
            subtitleAriaId={subtitleId}
            isOpen={true}
            onDismiss={onClose}
            isBlocking={false}
            isModeless={false}
            styles={StyleUtils.getModalWidthStyles(800)}
        >
            <ModalHeaderView title="Brands" onClose={onClose} />

            <div
                id={subtitleId}
                className={(isMobile ? "mobile-" : "") + "popup-body"}
                style={{ maxHeight: isMobile ? "" : "80vh", overflowY: "auto" }}
            >
                {vm.list.map((label) => {
                    return <div key={label.key}>
                        <div className="font-large font-bold p-10">
                            <div className="light-primary-background-color p-10">{label.text}</div>

                        </div>

                        {label.subMenuProps && <div style={{ display: "flow-root" }}>
                            <BrandGridView brands={label.subMenuProps.items} />
                        </div>}
                    </div>
                })}
            </div>
        </Modal>
    </>;
}